// extracted by mini-css-extract-plugin
export var card = "_42-0";
export var content = "_42-1";
export var contentLoading = "_42-2";